import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import BreadCrumb from '../../../component/BreadCrumb';

import InputBox from '../../../component/InputBox';
import ModalRef from '../../../component/ModalRef';
import PopupRef from '../../../component/PopupRef';
import { handleShow } from '../../../module/ErrorPopupModule';
import { BlueBgButtonBox } from '../../../component/buttons/CustomButtonBox';
import SubjectCodeSearchModal from '../../modal/SubjectCodeSearchModal';
import CodeUtil from '../../../util/CodeUtil';
import { CODE_GROUP_ID } from '../../../constant/Constant';
import SingleFileAttachBox from '../../../component/SingleFileAttachBox';
import CancelButtonBox from '../../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../../component/buttons/ConfirmButtonBox';
import CommunityDeleteButtonBox from '../../../component/buttons/CommunityDeleteButtonBox';
import CommunityEditButtonBox from '../../../component/buttons/CommunityEditButtonBox';
import TimeBox from '../../../component/TimeBox';
import CautionBox from '../../../component/CautionBox';
import DatePickerBox from '../../../component/DatePickerBox';
import DateTimePickerBox from '../../../component/DateTimePickerBox';
import { date2Millis, millis2Date } from '../../../util/TimeTableUtil';
import ExcelDownloadButtonBox from '../../../component/buttons/ExcelDownloadButtonBox';
import ExcelUploadButtonBox from '../../../component/buttons/ExcelUploadButtonBox';

// TODO 테스트용 삭제처리
const TestModalView = () => {
    const dispatch = useDispatch();
    const modalRef = useRef(null);
    const popupRef = useRef(null);

    const [errorMessage, setErrorMessage] = useState('에러메시지');
    const onClickError = () => {
        dispatch(handleShow(errorMessage));
    };

    const [normalMessage, setNormalMessage] = useState('일반팝업 ');
    const onClickNormal = () => {
        popupRef.current.open(normalMessage);
    };

    const [alertMessage, setAlertMessage] = useState('알림팝업 ');
    const onClickAlert = () => {
        popupRef.current.openAlert(alertMessage);
    };

    const [warningMessage, setWarningMessage] = useState('경고팝업 ');
    const onClickWarning = () => {
        popupRef.current.openWarning(warningMessage);
    };

    const [infoMessage, setInfoMessage] = useState('정보팝업 ');
    const onClickInfo = () => {
        popupRef.current.openInfo(infoMessage);
    };

    const [subjectId, setSubjectId] = useState('교과목ID');
    const [subjectNm, setSubjectNm] = useState('교과목');
    const [subjectType, setSubjectType] = useState('교과목타입');
    const onClickSubject = () => {
        modalRef.current.open(
            <SubjectCodeSearchModal
                callback={(subjectId, subjectNm, subjectTypeCd) => {
                    setSubjectId(subjectId);
                    setSubjectNm(subjectNm);
                    setSubjectType(CodeUtil.getCodeName(CODE_GROUP_ID.SUBJECT_TYPE, subjectTypeCd));
                }}
                modalRef={modalRef}
            />,
            'large',
        );
    };

    const [lessonPlanFileUid, setLessonPlanFileUid] = useState();
    const [lessonPlanFileNm, setLessonPlanFileNm] = useState();
    const onChangeFile = ({ fileUid, fileNm }) => {
        setLessonPlanFileUid(fileUid);
        setLessonPlanFileNm(fileNm);
    };

    const handleCancel = () => {};
    const [courseTimes, setCourseTimes] = useState([]);
    const [datepick, setDatepick] = useState();
    const [dateTimePick, setDateTimePick] = useState();

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg02'>
                    <h2 className='con-title'>모달/팝업 테스트</h2>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <div className='con-form-wrap '>
                    <div className='board-inner'>
                        <div className='board-row'>
                            <div className='lec-check-box'>
                                <div className='search-condition-box'>
                                    <div className='form-box-container'>
                                        <InputBox
                                            title='에러팝업 메시지'
                                            value={errorMessage}
                                            onChange={(e) => setErrorMessage(e.target.value)}
                                        />
                                        <BlueBgButtonBox title='에러팝업' onClick={onClickError} />
                                    </div>
                                    <div className='form-box-container'>
                                        <InputBox
                                            title='일반팝업 메시지'
                                            value={normalMessage}
                                            onChange={(e) => setNormalMessage(e.target.value)}
                                        />
                                        <BlueBgButtonBox title='open' onClick={onClickNormal} />
                                    </div>
                                    <div className='form-box-container'>
                                        <InputBox
                                            title='경고팝업 메시지'
                                            value={warningMessage}
                                            onChange={(e) => setWarningMessage(e.target.value)}
                                        />
                                        <BlueBgButtonBox title='openWarning' onClick={onClickWarning} />
                                    </div>

                                    <div className='form-box-container'>
                                        <InputBox
                                            title='알림팝업 메시지'
                                            value={alertMessage}
                                            onChange={(e) => setAlertMessage(e.target.value)}
                                        />
                                        <BlueBgButtonBox title='openAlert' onClick={onClickAlert} />
                                    </div>
                                    <div className='form-box-container'>
                                        <InputBox
                                            title='알림팝업 메시지'
                                            value={infoMessage}
                                            onChange={(e) => setInfoMessage(e.target.value)}
                                        />
                                        <BlueBgButtonBox title='openInfo' onClick={onClickInfo} />
                                    </div>
                                    <div className='form-box-container'>
                                        <InputBox
                                            title='교과목타입'
                                            value={subjectType}
                                            onChange={(e) => setWarningMessage(e.target.value)}
                                        />
                                        <InputBox
                                            title='교과목ID'
                                            value={subjectId}
                                            onChange={(e) => setWarningMessage(e.target.value)}
                                        />
                                        <InputBox
                                            title='교과목'
                                            value={subjectNm}
                                            onChange={(e) => setWarningMessage(e.target.value)}
                                        />
                                        <BlueBgButtonBox title='교과목모달' onClick={onClickSubject} />
                                    </div>

                                    <div className='form-box-container'>
                                        <InputBox title='FILE UID' value={lessonPlanFileUid} disabled />
                                        <InputBox title='FILE명' value={lessonPlanFileNm} disabled />
                                        <div style={{ width: 300 }}>
                                            <SingleFileAttachBox
                                                labelName={'파일'}
                                                fileUid={lessonPlanFileUid}
                                                fileNm={lessonPlanFileNm}
                                                onChangeFile={onChangeFile}
                                                download
                                                editable={true}
                                                availableTypes={['image/png', 'image/jpeg']}
                                            />
                                        </div>
                                    </div>

                                    <div className='form-box-container'>
                                        <div style={{ padding: 10 }}>
                                            <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                                        </div>
                                        <div style={{ padding: 10 }}>
                                            <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                                        </div>
                                        <div style={{ padding: 10 }}>
                                            <CommunityDeleteButtonBox title='삭제' onClick={(e) => handleConfirm()} />
                                        </div>
                                        <div style={{ padding: 10 }}>
                                            <CommunityEditButtonBox title='편집' onClick={(e) => handleConfirm()} />
                                        </div>
                                        <div style={{ padding: 10 }}>
                                            <ExcelDownloadButtonBox onClick={(e) => handleConfirm()} />
                                            <ExcelUploadButtonBox onClick={(e) => handleConfirm()} />
                                        </div>
                                    </div>

                                    <div className='form-box-container'>
                                        <TimeBox
                                            title=''
                                            disabled='add'
                                            times={courseTimes}
                                            onChange={setCourseTimes}
                                            edit='false'
                                        />
                                    </div>

                                    <div className='form-box-container'>
                                        <CautionBox
                                            title='수강신청 유의사항 확인'
                                            checkedEnabled={false}
                                            path='#none;'
                                        />
                                    </div>
                                    <div className='form-box-container'>
                                        <DatePickerBox title='' value={datepick} onChange={(date) => setDatepick()} />
                                        <DateTimePickerBox
                                            title=''
                                            value={millis2Date(dateTimePick)}
                                            onChange={(date) => setDateTimePick(date2Millis(date))}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalRef ref={modalRef} />
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default TestModalView;
